import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';

function ContactUs() {
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        messages: '',
        consent: false
    });

    const [errors, setErrors] = useState({});

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false); // New state variable to track form submission

    const validateInput = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstname':
            case 'lastname':
                if (!value.match(/^[A-Za-z]+$/)) {
                    error = 'This field should only contains alphabets.';
                }
                break;
            case 'email':
                if (!value.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)) {
                    error = 'Please enter a valid email address.';
                }
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const error = validateInput(name, value);
        setErrors({
            ...errors,
            [name]: error
        });
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const validationErrors = {};
        let isValid = true;
    
        Object.keys(formData).forEach((key) => {
            const error = validateInput(key, formData[key]);
            if (error) {
                isValid = false;
                validationErrors[key] = error;
            }
        });
    
        setErrors(validationErrors);
    
        if (!isValid) {
            return;
        }
    
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/contact_us_form.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                setSuccessMessage(data.message);
                setErrorMessage(''); // Clear any previous error message
                setIsSubmitted(true); // Set the form as submitted
                setFormData({ // Reset form fields
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    messages: '',
                    consent: false
                });
                setErrors({}); // Clear any previous validation errors
            } else {
                setErrorMessage(data.message);
                setSuccessMessage(''); // Clear any previous success message
            }
        })
        .catch((error) => {
            setErrorMessage('An error occurred. Please try again later.');
            setSuccessMessage(''); // Clear any previous success message
        });
    };
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Contact Us</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Get in touch with Caritas Matha Hospital for inquiries, 
                            <br/>
                            appointments, and assistance.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Get in touch with Caritas Matha Hospital for inquiries, appointments, and assistance.
                        </p>
                    </div>
                </div>
            </section>

            <section className="contact-us-container">
                {/* Contact Us Column */}
                <div className="contact-us-column">
                    <h6 className="contact-sub-heading">Address</h6>
                    <p className="footer-links"> MC Road, Thellakom (P.O), <br />Kottayam, Kerala - 686630</p>

                    <h6 className="contact-sub-heading">Contact Number</h6>
                    <a href="tel:04812790025"><p className="footer-links"> 0481-2790025 to 29</p></a>

                    <h6 className="contact-sub-heading">Email Id</h6>
                    <a href="mailto:mail@caritashospital.org"><p className="footer-links"> mail@caritashospital.org</p></a>

                    <h6 className="contact-sub-heading">Patient Feedback</h6>
                    <a href="mailto:patientfeedback@caritashospital.org"><p className="footer-links"> patientfeedback@caritashospital.org</p></a>
                </div>

                {/* Contact Us Form */}
                <div className="contact-us-form">
                    {!isSubmitted ? (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label style={{ color: 'red' }}>*</label>
                                <input
                                    type="text"
                                    name="firstname"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                    className="form-control"
                                />
                                {errors.firstname && <div style={{ color: 'red' }}>{errors.firstname}</div>}
                            </div>
                            <div className="form-group">
                                <label style={{ color: 'red' }}>*</label>
                                <input
                                    type="text"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                    className="form-control"
                                />
                                {errors.lastname && <div style={{ color: 'red' }}>{errors.lastname}</div>}
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label style={{ color: 'red' }}>*</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email"
                                        required
                                        className="form-control"
                                    />
                                    {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                                </div>
                                <div className="form-group col-md-6">
                                <label style={{ color: 'red' }}>*</label>
                                <input 
                                    type="text" 
                                    name="phone"
                                    className="form-control"
                                    value={formData.phone} 
                                    onChange={handleChange} 
                                    placeholder='Phone Number' 
                                    required 
                                    pattern="\d*"
                                    onInput={(e) => 
                                        e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <textarea
                                    name="messages"
                                    value={formData.messages}
                                    onChange={handleChange}
                                    placeholder="Message"
                                    className="form-control"
                                    rows="3"
                                    maxLength="500"  // Limit the number of characters to 500 (or any value you prefer)
                                    required
                                />
                            </div>
                            <div className="form-group form-check form-checkbox">
                                <input
                                    type="checkbox"
                                    name="consent"
                                    checked={formData.consent}
                                    onChange={handleChange}
                                    required
                                    className="form-check-input"
                                />
                                <label className="form-check-label">
                                By ticking, I agree to the Terms and Conditions, and I am giving my consent to receive updates through email and SMS. 
                                </label>
                            </div>
                            {/* <div className="form-group">
                                <div className="g-recaptcha" data-sitekey="6Ld5BysqAAAAAPDbNP108w_N2QQRKR60zn2UlSti"></div>
                            </div> */}
                            <button type="submit" className="form-button">Submit Now</button>
                        </form>
                    ) : (
                        <div className="success-message">
                            <h1>Thank You!</h1>
                            <p>Your message has been successfully submitted.</p>
                        </div>
                    )}
                </div>
            </section>

            <section>
                <div className="contact-map-container">
                    <div className='map-title'>
                        <p className="sub-heading">Google Map Location</p>
                    </div>
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3933.429665891083!2d76.54812431602198!3d9.64830593217464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07d358c6fffffd%3A0x28bcae68ab08dd22!2sMatha%20Hospital!5e0!3m2!1sen!2sin!4v1697534628764!5m2!1sen!2sin"
                        width="95%"
                        height="500"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
                </div>
            </section>

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default ContactUs;
